export const DELIVERY_TEAMS_FETCH_BEGIN = 'syftacp/DELIVERY_TEAMS_FETCH_BEGIN'
export const DELIVERY_TEAMS_FETCH_FAILED = 'syftacp/DELIVERY_TEAMS_FETCH_FAILED'
export const DELIVERY_TEAMS_FETCH_SUCCEEDED = 'syftacp/DELIVERY_TEAMS_FETCH_SUCCEEDED'
